/** @format */

export const ACCOUNT_FIELD = 'ACCOUNT';
export const AD_GROUP_FIELD = 'AD_GROUP';
export const AD_FIELD = 'AD';
export const CAMPAIGN_FIELD = 'CAMPAIGN';
export const KEYWORD_FIELD = 'KEYWORD';
export const OBJECT_LINK_FIELD = 'OBJECT_LINK';
export const OBJECT_HOST_FIELD = 'OBJECT_HOST';
